import { DeleteTwoTone } from "@ant-design/icons";
import { message, Popconfirm } from "antd";
import React from "react";
import { useDispatch } from "react-redux";
import { deleteOverride } from "../../../redux/Overrides/actions";

export const DeleteOverride = ({ item }) => {
    const dispatch = useDispatch();

    const deleteOverrideFun = () => {
        dispatch(deleteOverride(item._id));
        message.success("Deleted");
    };

    const confirm = () => {
        deleteOverrideFun();
    };

    const cancel = () => {};

    return (
        <Popconfirm
            onConfirm={confirm}
            onCancel={cancel}
            title="Are you sure you want to delete this override?"
            okText="Yes"
            cancelText="No"
        >
            <DeleteTwoTone twoToneColor="red" />
        </Popconfirm>
    );
};

export default DeleteOverride;
